import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { style } from "../form/styles";
import {} from "@material-ui/core";
import Header from "../../../partials/header";
import Loading from "../../loading";
import Form from "../form";

export class CreateProductMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  async componentDidMount() {}
  handleCreate = async (data) => {
    this.loading.startLoading();
    let result = await this.props.insertPluginCategory(data);
    this.loading.stopLoading();
    if (result.code === 1) this.props.history.push("/pluginCategory");
    // else this.
  };
  render() {
    const { t, classes } = this.props;
    return (
      <>
        <Header
          session={t("plugin_category")}
          title={t("create_plugin_category")}
          // button={t("product_create")}
          // actionButton={this.insertProduct}
          backIcon={true}
          actionBack={() => this.props.history.push("/pluginCategory")}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Form handleCreate={this.handleCreate} />
      </>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  insertPluginCategory: dispatch.pluginCategory.insertPluginCategory,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(style, { withTheme: 0 })(CreateProductMenu)
  )
);
